import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, ShieldCheck, Truck, Settings, Briefcase } from 'lucide-react';
import { Button } from './ui/Button';
import { Container } from './ui/Container';
const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/uploads/1ujANXvSLD4QJjSbE8bms8/ChatGPT_Image_May_9,_2026,_11_52_25_PM.png'
};
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-[#FDFBF7] pt-8 pb-20 overflow-hidden" data-id="element-159">
      <Container data-id="element-160">
        {/* Mobile Header Logo */}
        <div className="flex justify-center mb-8 md:hidden" data-id="element-161">
          <img src="https://cdn.magicpatterns.com/uploads/j7d4EdH3Rp1gzCoto8E26y/imgi_1_1746975280-SnoreStop™.png" alt="SnoreStop Logo" className="h-8 opacity-80" data-id="element-162" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-163">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-164">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight" data-id="element-165">
              At Some Point The Separate Sleeping Just Became Normal
            </h1>

            <div className="space-y-4 text-lg text-gray-600 leading-relaxed" data-id="element-166">
              <p data-id="element-167">
                You stopped falling asleep together. Stopped taking trips the
                same way. Stopped bringing it up because it felt easier than
                having the same conversation again.
              </p>
              <p data-id="element-168">
                And somehow the snoring slowly became part of the relationship.
              </p>
              <p className="font-medium text-gray-900" data-id="element-169">
                SnoreStop™ was created for couples who are tired of pretending
                it is “not that bad.”
              </p>
            </div>

            {/* Benefits List */}
            <ul className="space-y-4 bg-white/50 p-6 rounded-2xl border border-gray-100" data-id="element-170">
              {['Comfortable overnight fit', 'No loud machines or bulky equipment', 'Helps support a more open airway during sleep', 'Simple nightly routine in under 30 seconds'].map((benefit, index) => <li key={index} className="flex items-start space-x-3" data-id="element-171">
                  <div className="flex-shrink-0 mt-1" data-id="element-172">
                    <Check className="w-5 h-5 text-[#1E40AF]" data-id="element-173" />
                  </div>
                  <span className="text-gray-700" data-id="element-174">{benefit}</span>
                </li>)}
            </ul>

            <div className="pt-2" data-id="element-175">
              <Button onClick={scrollToPricing} size="lg" className="w-full sm:w-auto shadow-xl shadow-blue-900/10 text-lg px-8" data-id="element-176">
                I Just Want Quiet Sleep Again
              </Button>
            </div>

            {/* Trust Badges */}
            <div className="pt-6 border-t border-gray-200" data-id="element-177">
              <div className="flex items-center space-x-2 mb-4" data-id="element-178">
                <div className="flex text-orange-400" data-id="element-179">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-180" />)}
                </div>
                <span className="text-sm font-medium text-gray-600" data-id="element-181">
                  Trusted by thousands of couples across the USA
                </span>
              </div>

              <div className="grid grid-cols-2 gap-y-3 gap-x-4 text-xs text-gray-500" data-id="element-182">
                <span className="flex items-center" data-id="element-183">
                  <ShieldCheck className="w-4 h-4 mr-1.5 text-gray-400" data-id="element-184" /> 60
                  Night Money Back Guarantee
                </span>
                <span className="flex items-center" data-id="element-185">
                  <Truck className="w-4 h-4 mr-1.5 text-gray-400" data-id="element-186" /> Fast USA
                  Shipping
                </span>
                <span className="flex items-center" data-id="element-187">
                  <Settings className="w-4 h-4 mr-1.5 text-gray-400" data-id="element-188" />{' '}
                  Comfortable Adjustable Design
                </span>
                <span className="flex items-center" data-id="element-189">
                  <Briefcase className="w-4 h-4 mr-1.5 text-gray-400" data-id="element-190" />{' '}
                  Reusable Travel Case Included
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-191">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-192">
              <img src={IMAGES.hero} alt="Before and after using SnoreStop — couple sleeping peacefully" className="w-full h-auto object-cover" data-id="element-193" />
            </div>
          </motion.div>
        </div>
      </Container>
    </section>;
}